// extracted by mini-css-extract-plugin
export default {"root":"eg_W1HSBIM"};